import { createContext, useContext } from 'react';

import { useOrganizationTimezone } from '@apps/web/context/timezone_provider';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';

export type PhoebeChatOrganizationScope = {
    readonly organizationId: string | null;
    readonly timezone: string;
};

export const PhoebeChatOrganizationScopeContext =
    createContext<PhoebeChatOrganizationScope | null>(null);

export function usePhoebeChatOrganizationScope(): PhoebeChatOrganizationScope {
    const scopedOrganization = useContext(PhoebeChatOrganizationScopeContext);
    const fallbackOrganizationId = useOrganizationId();
    const { timezone: fallbackTimezone } = useOrganizationTimezone();

    return (
        scopedOrganization ?? {
            organizationId: fallbackOrganizationId,
            timezone: fallbackTimezone,
        }
    );
}
